import {
  useMutation,
  useQuery
} from '@tanstack/vue-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query'
import {
  unref
} from 'vue'
import type {
  MaybeRef
} from 'vue'
import type {
  AccountDirectSalesListingResponseDto,
  AccountNegotiationsResponseDto,
  AccountOrdersBuyerResponseDto,
  AccountSalesResponseDto,
  AdminPasswordResetBodyDto,
  AdminPasswordResetResponseDto,
  AdminUserResponseWithGrantType,
  ApiAccountAuctionsBuyerParams,
  ApiAccountDirectSalesBuyerParams,
  ApiAccountOrdersBuyerParams,
  ApiAccountSalesBuyerNegotiationsParams,
  ApiAccountSalesParams,
  ApiAccountSalesSellerNegotiationsParams,
  AuctionsListingResponseDto,
  BackendErrorEntity,
  CompleteOnboardingSessionBodyDto,
  CompleteOnboardingSessionResponseDto,
  LoginEntity,
  RequestAdminPasswordResetBodyDto,
  RequestEmailChangeBodyDto,
  SendOtpBodyDto,
  UpdateAccountBodyDto,
  UpdateAccountCompanyBodyDto,
  UpdateAccountCompanyResponseDto,
  UpdateAccountDto,
  UpdateAccountResponseDto,
  UpdateLegalAgreementsBodyDto,
  UpdateLegalAgreementsResponseDto,
  UserEntity,
  VerifyOtpBodyDto
} from '.././types'
import { fetchApiInstance } from '../../fetchApiInstance';
import type { ErrorType, BodyType } from '../../fetchApiInstance';


type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];


export const apiUpdateAccountPersonalData = (
    updateAccountDto: MaybeRef<UpdateAccountDto>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      updateAccountDto = unref(updateAccountDto);
      
      return fetchApiInstance<UserEntity>(
      {url: `/account/personalData`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateAccountDto
    },
      options);
    }
  


export const getApiUpdateAccountPersonalDataMutationOptions = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiUpdateAccountPersonalData>>, TError,{data: BodyType<UpdateAccountDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiUpdateAccountPersonalData>>, TError,{data: BodyType<UpdateAccountDto>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiUpdateAccountPersonalData>>, {data: BodyType<UpdateAccountDto>}> = (props) => {
          const {data} = props ?? {};

          return  apiUpdateAccountPersonalData(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiUpdateAccountPersonalDataMutationResult = NonNullable<Awaited<ReturnType<typeof apiUpdateAccountPersonalData>>>
    export type ApiUpdateAccountPersonalDataMutationBody = BodyType<UpdateAccountDto>
    export type ApiUpdateAccountPersonalDataMutationError = ErrorType<BackendErrorEntity>

    export const useApiUpdateAccountPersonalData = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiUpdateAccountPersonalData>>, TError,{data: BodyType<UpdateAccountDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof apiUpdateAccountPersonalData>>,
        TError,
        {data: BodyType<UpdateAccountDto>},
        TContext
      > => {

      const mutationOptions = getApiUpdateAccountPersonalDataMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const apiAdminMe = (
    
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      
      
      return fetchApiInstance<AdminUserResponseWithGrantType>(
      {url: `/account/admin/me`, method: 'GET'
    },
      options);
    }
  

export const getApiAdminMeQueryKey = () => {
    return ['account','admin','me'] as const;
    }

    
export const getApiAdminMeQueryOptions = <TData = Awaited<ReturnType<typeof apiAdminMe>>, TError = ErrorType<BackendErrorEntity>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof apiAdminMe>>, TError, TData>, request?: SecondParameter<typeof fetchApiInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getApiAdminMeQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiAdminMe>>> = () => apiAdminMe(requestOptions);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiAdminMe>>, TError, TData> 
}

export type ApiAdminMeQueryResult = NonNullable<Awaited<ReturnType<typeof apiAdminMe>>>
export type ApiAdminMeQueryError = ErrorType<BackendErrorEntity>



export function useApiAdminMe<TData = Awaited<ReturnType<typeof apiAdminMe>>, TError = ErrorType<BackendErrorEntity>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof apiAdminMe>>, TError, TData>, request?: SecondParameter<typeof fetchApiInstance>}

  ): UseQueryReturnType<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getApiAdminMeQueryOptions(options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: QueryKey };

  query.queryKey = unref(queryOptions).queryKey as QueryKey;

  return query;
}



export const apiRequestAdminPasswordReset = (
    requestAdminPasswordResetBodyDto: MaybeRef<RequestAdminPasswordResetBodyDto>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      requestAdminPasswordResetBodyDto = unref(requestAdminPasswordResetBodyDto);
      
      return fetchApiInstance<void>(
      {url: `/account/admin/requestPasswordReset`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: requestAdminPasswordResetBodyDto
    },
      options);
    }
  


export const getApiRequestAdminPasswordResetMutationOptions = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiRequestAdminPasswordReset>>, TError,{data: BodyType<RequestAdminPasswordResetBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiRequestAdminPasswordReset>>, TError,{data: BodyType<RequestAdminPasswordResetBodyDto>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiRequestAdminPasswordReset>>, {data: BodyType<RequestAdminPasswordResetBodyDto>}> = (props) => {
          const {data} = props ?? {};

          return  apiRequestAdminPasswordReset(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiRequestAdminPasswordResetMutationResult = NonNullable<Awaited<ReturnType<typeof apiRequestAdminPasswordReset>>>
    export type ApiRequestAdminPasswordResetMutationBody = BodyType<RequestAdminPasswordResetBodyDto>
    export type ApiRequestAdminPasswordResetMutationError = ErrorType<BackendErrorEntity>

    export const useApiRequestAdminPasswordReset = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiRequestAdminPasswordReset>>, TError,{data: BodyType<RequestAdminPasswordResetBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof apiRequestAdminPasswordReset>>,
        TError,
        {data: BodyType<RequestAdminPasswordResetBodyDto>},
        TContext
      > => {

      const mutationOptions = getApiRequestAdminPasswordResetMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const apiAdminPasswordReset = (
    adminPasswordResetBodyDto: MaybeRef<AdminPasswordResetBodyDto>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      adminPasswordResetBodyDto = unref(adminPasswordResetBodyDto);
      
      return fetchApiInstance<AdminPasswordResetResponseDto>(
      {url: `/account/admin/passwordReset`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: adminPasswordResetBodyDto
    },
      options);
    }
  


export const getApiAdminPasswordResetMutationOptions = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdminPasswordReset>>, TError,{data: BodyType<AdminPasswordResetBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiAdminPasswordReset>>, TError,{data: BodyType<AdminPasswordResetBodyDto>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiAdminPasswordReset>>, {data: BodyType<AdminPasswordResetBodyDto>}> = (props) => {
          const {data} = props ?? {};

          return  apiAdminPasswordReset(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiAdminPasswordResetMutationResult = NonNullable<Awaited<ReturnType<typeof apiAdminPasswordReset>>>
    export type ApiAdminPasswordResetMutationBody = BodyType<AdminPasswordResetBodyDto>
    export type ApiAdminPasswordResetMutationError = ErrorType<BackendErrorEntity>

    export const useApiAdminPasswordReset = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdminPasswordReset>>, TError,{data: BodyType<AdminPasswordResetBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof apiAdminPasswordReset>>,
        TError,
        {data: BodyType<AdminPasswordResetBodyDto>},
        TContext
      > => {

      const mutationOptions = getApiAdminPasswordResetMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const apiAccountDirectSalesBuyer = (
    params?: MaybeRef<ApiAccountDirectSalesBuyerParams>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      params = unref(params);
      
      return fetchApiInstance<AccountDirectSalesListingResponseDto>(
      {url: `/account/directSales/buyer`, method: 'GET',
        params: unref(params)
    },
      options);
    }
  

export const getApiAccountDirectSalesBuyerQueryKey = (params?: MaybeRef<ApiAccountDirectSalesBuyerParams>,) => {
    return ['account','directSales','buyer', ...(params ? [params]: [])] as const;
    }

    
export const getApiAccountDirectSalesBuyerQueryOptions = <TData = Awaited<ReturnType<typeof apiAccountDirectSalesBuyer>>, TError = ErrorType<BackendErrorEntity>>(params?: MaybeRef<ApiAccountDirectSalesBuyerParams>, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof apiAccountDirectSalesBuyer>>, TError, TData>, request?: SecondParameter<typeof fetchApiInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getApiAccountDirectSalesBuyerQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiAccountDirectSalesBuyer>>> = () => apiAccountDirectSalesBuyer(params, requestOptions);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiAccountDirectSalesBuyer>>, TError, TData> 
}

export type ApiAccountDirectSalesBuyerQueryResult = NonNullable<Awaited<ReturnType<typeof apiAccountDirectSalesBuyer>>>
export type ApiAccountDirectSalesBuyerQueryError = ErrorType<BackendErrorEntity>



export function useApiAccountDirectSalesBuyer<TData = Awaited<ReturnType<typeof apiAccountDirectSalesBuyer>>, TError = ErrorType<BackendErrorEntity>>(
 params?: MaybeRef<ApiAccountDirectSalesBuyerParams>, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof apiAccountDirectSalesBuyer>>, TError, TData>, request?: SecondParameter<typeof fetchApiInstance>}

  ): UseQueryReturnType<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getApiAccountDirectSalesBuyerQueryOptions(params,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: QueryKey };

  query.queryKey = unref(queryOptions).queryKey as QueryKey;

  return query;
}



export const apiAccountOrdersBuyer = (
    params?: MaybeRef<ApiAccountOrdersBuyerParams>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      params = unref(params);
      
      return fetchApiInstance<AccountOrdersBuyerResponseDto>(
      {url: `/account/orders/buyer`, method: 'GET',
        params: unref(params)
    },
      options);
    }
  

export const getApiAccountOrdersBuyerQueryKey = (params?: MaybeRef<ApiAccountOrdersBuyerParams>,) => {
    return ['account','orders','buyer', ...(params ? [params]: [])] as const;
    }

    
export const getApiAccountOrdersBuyerQueryOptions = <TData = Awaited<ReturnType<typeof apiAccountOrdersBuyer>>, TError = ErrorType<BackendErrorEntity>>(params?: MaybeRef<ApiAccountOrdersBuyerParams>, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof apiAccountOrdersBuyer>>, TError, TData>, request?: SecondParameter<typeof fetchApiInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getApiAccountOrdersBuyerQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiAccountOrdersBuyer>>> = () => apiAccountOrdersBuyer(params, requestOptions);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiAccountOrdersBuyer>>, TError, TData> 
}

export type ApiAccountOrdersBuyerQueryResult = NonNullable<Awaited<ReturnType<typeof apiAccountOrdersBuyer>>>
export type ApiAccountOrdersBuyerQueryError = ErrorType<BackendErrorEntity>



export function useApiAccountOrdersBuyer<TData = Awaited<ReturnType<typeof apiAccountOrdersBuyer>>, TError = ErrorType<BackendErrorEntity>>(
 params?: MaybeRef<ApiAccountOrdersBuyerParams>, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof apiAccountOrdersBuyer>>, TError, TData>, request?: SecondParameter<typeof fetchApiInstance>}

  ): UseQueryReturnType<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getApiAccountOrdersBuyerQueryOptions(params,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: QueryKey };

  query.queryKey = unref(queryOptions).queryKey as QueryKey;

  return query;
}



export const apiUpdateAccountCompany = (
    updateAccountCompanyBodyDto: MaybeRef<UpdateAccountCompanyBodyDto>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      updateAccountCompanyBodyDto = unref(updateAccountCompanyBodyDto);
      const formData = new FormData();
if(updateAccountCompanyBodyDto.operatorType !== undefined) {
 formData.append('operatorType', updateAccountCompanyBodyDto.operatorType)
 }
if(updateAccountCompanyBodyDto.companyRegistrationReportFile !== undefined && updateAccountCompanyBodyDto.companyRegistrationReportFile !== null) {
 formData.append('companyRegistrationReportFile', updateAccountCompanyBodyDto.companyRegistrationReportFile)
 }
if(updateAccountCompanyBodyDto.companyRegistrationReportIssueDate !== undefined && updateAccountCompanyBodyDto.companyRegistrationReportIssueDate !== null) {
 formData.append('companyRegistrationReportIssueDate', updateAccountCompanyBodyDto.companyRegistrationReportIssueDate)
 }

      return fetchApiInstance<UpdateAccountCompanyResponseDto>(
      {url: `/account/company`, method: 'PATCH',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData
    },
      options);
    }
  


export const getApiUpdateAccountCompanyMutationOptions = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiUpdateAccountCompany>>, TError,{data: BodyType<UpdateAccountCompanyBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiUpdateAccountCompany>>, TError,{data: BodyType<UpdateAccountCompanyBodyDto>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiUpdateAccountCompany>>, {data: BodyType<UpdateAccountCompanyBodyDto>}> = (props) => {
          const {data} = props ?? {};

          return  apiUpdateAccountCompany(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiUpdateAccountCompanyMutationResult = NonNullable<Awaited<ReturnType<typeof apiUpdateAccountCompany>>>
    export type ApiUpdateAccountCompanyMutationBody = BodyType<UpdateAccountCompanyBodyDto>
    export type ApiUpdateAccountCompanyMutationError = ErrorType<BackendErrorEntity>

    export const useApiUpdateAccountCompany = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiUpdateAccountCompany>>, TError,{data: BodyType<UpdateAccountCompanyBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof apiUpdateAccountCompany>>,
        TError,
        {data: BodyType<UpdateAccountCompanyBodyDto>},
        TContext
      > => {

      const mutationOptions = getApiUpdateAccountCompanyMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const apiUpdateAccount = (
    updateAccountBodyDto: MaybeRef<UpdateAccountBodyDto>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      updateAccountBodyDto = unref(updateAccountBodyDto);
      
      return fetchApiInstance<UpdateAccountResponseDto>(
      {url: `/account`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateAccountBodyDto
    },
      options);
    }
  


export const getApiUpdateAccountMutationOptions = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiUpdateAccount>>, TError,{data: BodyType<UpdateAccountBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiUpdateAccount>>, TError,{data: BodyType<UpdateAccountBodyDto>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiUpdateAccount>>, {data: BodyType<UpdateAccountBodyDto>}> = (props) => {
          const {data} = props ?? {};

          return  apiUpdateAccount(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiUpdateAccountMutationResult = NonNullable<Awaited<ReturnType<typeof apiUpdateAccount>>>
    export type ApiUpdateAccountMutationBody = BodyType<UpdateAccountBodyDto>
    export type ApiUpdateAccountMutationError = ErrorType<BackendErrorEntity>

    export const useApiUpdateAccount = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiUpdateAccount>>, TError,{data: BodyType<UpdateAccountBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof apiUpdateAccount>>,
        TError,
        {data: BodyType<UpdateAccountBodyDto>},
        TContext
      > => {

      const mutationOptions = getApiUpdateAccountMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const apiUpdateLegalAgreements = (
    updateLegalAgreementsBodyDto: MaybeRef<UpdateLegalAgreementsBodyDto>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      updateLegalAgreementsBodyDto = unref(updateLegalAgreementsBodyDto);
      
      return fetchApiInstance<UpdateLegalAgreementsResponseDto>(
      {url: `/account/legalAgreements`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateLegalAgreementsBodyDto
    },
      options);
    }
  


export const getApiUpdateLegalAgreementsMutationOptions = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiUpdateLegalAgreements>>, TError,{data: BodyType<UpdateLegalAgreementsBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiUpdateLegalAgreements>>, TError,{data: BodyType<UpdateLegalAgreementsBodyDto>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiUpdateLegalAgreements>>, {data: BodyType<UpdateLegalAgreementsBodyDto>}> = (props) => {
          const {data} = props ?? {};

          return  apiUpdateLegalAgreements(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiUpdateLegalAgreementsMutationResult = NonNullable<Awaited<ReturnType<typeof apiUpdateLegalAgreements>>>
    export type ApiUpdateLegalAgreementsMutationBody = BodyType<UpdateLegalAgreementsBodyDto>
    export type ApiUpdateLegalAgreementsMutationError = ErrorType<BackendErrorEntity>

    export const useApiUpdateLegalAgreements = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiUpdateLegalAgreements>>, TError,{data: BodyType<UpdateLegalAgreementsBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof apiUpdateLegalAgreements>>,
        TError,
        {data: BodyType<UpdateLegalAgreementsBodyDto>},
        TContext
      > => {

      const mutationOptions = getApiUpdateLegalAgreementsMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const apiCompleteOnboardingSession = (
    completeOnboardingSessionBodyDto: MaybeRef<CompleteOnboardingSessionBodyDto>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      completeOnboardingSessionBodyDto = unref(completeOnboardingSessionBodyDto);
      
      return fetchApiInstance<CompleteOnboardingSessionResponseDto>(
      {url: `/account/completeOnboardingSession`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: completeOnboardingSessionBodyDto
    },
      options);
    }
  


export const getApiCompleteOnboardingSessionMutationOptions = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiCompleteOnboardingSession>>, TError,{data: BodyType<CompleteOnboardingSessionBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiCompleteOnboardingSession>>, TError,{data: BodyType<CompleteOnboardingSessionBodyDto>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiCompleteOnboardingSession>>, {data: BodyType<CompleteOnboardingSessionBodyDto>}> = (props) => {
          const {data} = props ?? {};

          return  apiCompleteOnboardingSession(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiCompleteOnboardingSessionMutationResult = NonNullable<Awaited<ReturnType<typeof apiCompleteOnboardingSession>>>
    export type ApiCompleteOnboardingSessionMutationBody = BodyType<CompleteOnboardingSessionBodyDto>
    export type ApiCompleteOnboardingSessionMutationError = ErrorType<BackendErrorEntity>

    export const useApiCompleteOnboardingSession = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiCompleteOnboardingSession>>, TError,{data: BodyType<CompleteOnboardingSessionBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof apiCompleteOnboardingSession>>,
        TError,
        {data: BodyType<CompleteOnboardingSessionBodyDto>},
        TContext
      > => {

      const mutationOptions = getApiCompleteOnboardingSessionMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const apiAccountAuctionsBuyer = (
    params?: MaybeRef<ApiAccountAuctionsBuyerParams>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      params = unref(params);
      
      return fetchApiInstance<AuctionsListingResponseDto>(
      {url: `/account/auctions/buyer`, method: 'GET',
        params: unref(params)
    },
      options);
    }
  

export const getApiAccountAuctionsBuyerQueryKey = (params?: MaybeRef<ApiAccountAuctionsBuyerParams>,) => {
    return ['account','auctions','buyer', ...(params ? [params]: [])] as const;
    }

    
export const getApiAccountAuctionsBuyerQueryOptions = <TData = Awaited<ReturnType<typeof apiAccountAuctionsBuyer>>, TError = ErrorType<BackendErrorEntity>>(params?: MaybeRef<ApiAccountAuctionsBuyerParams>, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof apiAccountAuctionsBuyer>>, TError, TData>, request?: SecondParameter<typeof fetchApiInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getApiAccountAuctionsBuyerQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiAccountAuctionsBuyer>>> = () => apiAccountAuctionsBuyer(params, requestOptions);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiAccountAuctionsBuyer>>, TError, TData> 
}

export type ApiAccountAuctionsBuyerQueryResult = NonNullable<Awaited<ReturnType<typeof apiAccountAuctionsBuyer>>>
export type ApiAccountAuctionsBuyerQueryError = ErrorType<BackendErrorEntity>



export function useApiAccountAuctionsBuyer<TData = Awaited<ReturnType<typeof apiAccountAuctionsBuyer>>, TError = ErrorType<BackendErrorEntity>>(
 params?: MaybeRef<ApiAccountAuctionsBuyerParams>, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof apiAccountAuctionsBuyer>>, TError, TData>, request?: SecondParameter<typeof fetchApiInstance>}

  ): UseQueryReturnType<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getApiAccountAuctionsBuyerQueryOptions(params,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: QueryKey };

  query.queryKey = unref(queryOptions).queryKey as QueryKey;

  return query;
}



export const apiAccountSalesBuyerNegotiations = (
    params?: MaybeRef<ApiAccountSalesBuyerNegotiationsParams>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      params = unref(params);
      
      return fetchApiInstance<AccountNegotiationsResponseDto>(
      {url: `/account/sales/buyer/negotiations`, method: 'GET',
        params: unref(params)
    },
      options);
    }
  

export const getApiAccountSalesBuyerNegotiationsQueryKey = (params?: MaybeRef<ApiAccountSalesBuyerNegotiationsParams>,) => {
    return ['account','sales','buyer','negotiations', ...(params ? [params]: [])] as const;
    }

    
export const getApiAccountSalesBuyerNegotiationsQueryOptions = <TData = Awaited<ReturnType<typeof apiAccountSalesBuyerNegotiations>>, TError = ErrorType<BackendErrorEntity>>(params?: MaybeRef<ApiAccountSalesBuyerNegotiationsParams>, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof apiAccountSalesBuyerNegotiations>>, TError, TData>, request?: SecondParameter<typeof fetchApiInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getApiAccountSalesBuyerNegotiationsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiAccountSalesBuyerNegotiations>>> = () => apiAccountSalesBuyerNegotiations(params, requestOptions);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiAccountSalesBuyerNegotiations>>, TError, TData> 
}

export type ApiAccountSalesBuyerNegotiationsQueryResult = NonNullable<Awaited<ReturnType<typeof apiAccountSalesBuyerNegotiations>>>
export type ApiAccountSalesBuyerNegotiationsQueryError = ErrorType<BackendErrorEntity>



export function useApiAccountSalesBuyerNegotiations<TData = Awaited<ReturnType<typeof apiAccountSalesBuyerNegotiations>>, TError = ErrorType<BackendErrorEntity>>(
 params?: MaybeRef<ApiAccountSalesBuyerNegotiationsParams>, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof apiAccountSalesBuyerNegotiations>>, TError, TData>, request?: SecondParameter<typeof fetchApiInstance>}

  ): UseQueryReturnType<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getApiAccountSalesBuyerNegotiationsQueryOptions(params,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: QueryKey };

  query.queryKey = unref(queryOptions).queryKey as QueryKey;

  return query;
}



export const apiAccountSalesSellerNegotiations = (
    params?: MaybeRef<ApiAccountSalesSellerNegotiationsParams>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      params = unref(params);
      
      return fetchApiInstance<AccountNegotiationsResponseDto>(
      {url: `/account/sales/seller/negotiations`, method: 'GET',
        params: unref(params)
    },
      options);
    }
  

export const getApiAccountSalesSellerNegotiationsQueryKey = (params?: MaybeRef<ApiAccountSalesSellerNegotiationsParams>,) => {
    return ['account','sales','seller','negotiations', ...(params ? [params]: [])] as const;
    }

    
export const getApiAccountSalesSellerNegotiationsQueryOptions = <TData = Awaited<ReturnType<typeof apiAccountSalesSellerNegotiations>>, TError = ErrorType<BackendErrorEntity>>(params?: MaybeRef<ApiAccountSalesSellerNegotiationsParams>, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof apiAccountSalesSellerNegotiations>>, TError, TData>, request?: SecondParameter<typeof fetchApiInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getApiAccountSalesSellerNegotiationsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiAccountSalesSellerNegotiations>>> = () => apiAccountSalesSellerNegotiations(params, requestOptions);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiAccountSalesSellerNegotiations>>, TError, TData> 
}

export type ApiAccountSalesSellerNegotiationsQueryResult = NonNullable<Awaited<ReturnType<typeof apiAccountSalesSellerNegotiations>>>
export type ApiAccountSalesSellerNegotiationsQueryError = ErrorType<BackendErrorEntity>



export function useApiAccountSalesSellerNegotiations<TData = Awaited<ReturnType<typeof apiAccountSalesSellerNegotiations>>, TError = ErrorType<BackendErrorEntity>>(
 params?: MaybeRef<ApiAccountSalesSellerNegotiationsParams>, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof apiAccountSalesSellerNegotiations>>, TError, TData>, request?: SecondParameter<typeof fetchApiInstance>}

  ): UseQueryReturnType<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getApiAccountSalesSellerNegotiationsQueryOptions(params,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: QueryKey };

  query.queryKey = unref(queryOptions).queryKey as QueryKey;

  return query;
}



export const apiAccountSales = (
    params?: MaybeRef<ApiAccountSalesParams>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      params = unref(params);
      
      return fetchApiInstance<AccountSalesResponseDto>(
      {url: `/account/sales`, method: 'GET',
        params: unref(params)
    },
      options);
    }
  

export const getApiAccountSalesQueryKey = (params?: MaybeRef<ApiAccountSalesParams>,) => {
    return ['account','sales', ...(params ? [params]: [])] as const;
    }

    
export const getApiAccountSalesQueryOptions = <TData = Awaited<ReturnType<typeof apiAccountSales>>, TError = ErrorType<BackendErrorEntity>>(params?: MaybeRef<ApiAccountSalesParams>, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof apiAccountSales>>, TError, TData>, request?: SecondParameter<typeof fetchApiInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getApiAccountSalesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiAccountSales>>> = () => apiAccountSales(params, requestOptions);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiAccountSales>>, TError, TData> 
}

export type ApiAccountSalesQueryResult = NonNullable<Awaited<ReturnType<typeof apiAccountSales>>>
export type ApiAccountSalesQueryError = ErrorType<BackendErrorEntity>



export function useApiAccountSales<TData = Awaited<ReturnType<typeof apiAccountSales>>, TError = ErrorType<BackendErrorEntity>>(
 params?: MaybeRef<ApiAccountSalesParams>, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof apiAccountSales>>, TError, TData>, request?: SecondParameter<typeof fetchApiInstance>}

  ): UseQueryReturnType<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getApiAccountSalesQueryOptions(params,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: QueryKey };

  query.queryKey = unref(queryOptions).queryKey as QueryKey;

  return query;
}



export const apiRequestEmailChange = (
    requestEmailChangeBodyDto: MaybeRef<RequestEmailChangeBodyDto>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      requestEmailChangeBodyDto = unref(requestEmailChangeBodyDto);
      
      return fetchApiInstance<void>(
      {url: `/account/requestEmailChange`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: requestEmailChangeBodyDto
    },
      options);
    }
  


export const getApiRequestEmailChangeMutationOptions = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiRequestEmailChange>>, TError,{data: BodyType<RequestEmailChangeBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiRequestEmailChange>>, TError,{data: BodyType<RequestEmailChangeBodyDto>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiRequestEmailChange>>, {data: BodyType<RequestEmailChangeBodyDto>}> = (props) => {
          const {data} = props ?? {};

          return  apiRequestEmailChange(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiRequestEmailChangeMutationResult = NonNullable<Awaited<ReturnType<typeof apiRequestEmailChange>>>
    export type ApiRequestEmailChangeMutationBody = BodyType<RequestEmailChangeBodyDto>
    export type ApiRequestEmailChangeMutationError = ErrorType<BackendErrorEntity>

    export const useApiRequestEmailChange = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiRequestEmailChange>>, TError,{data: BodyType<RequestEmailChangeBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof apiRequestEmailChange>>,
        TError,
        {data: BodyType<RequestEmailChangeBodyDto>},
        TContext
      > => {

      const mutationOptions = getApiRequestEmailChangeMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const apiConfirmEmailChangeRequest = (
    verifyOtpBodyDto: MaybeRef<VerifyOtpBodyDto>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      verifyOtpBodyDto = unref(verifyOtpBodyDto);
      
      return fetchApiInstance<void>(
      {url: `/account/confirmEmailChangeRequest`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: verifyOtpBodyDto
    },
      options);
    }
  


export const getApiConfirmEmailChangeRequestMutationOptions = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiConfirmEmailChangeRequest>>, TError,{data: BodyType<VerifyOtpBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiConfirmEmailChangeRequest>>, TError,{data: BodyType<VerifyOtpBodyDto>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiConfirmEmailChangeRequest>>, {data: BodyType<VerifyOtpBodyDto>}> = (props) => {
          const {data} = props ?? {};

          return  apiConfirmEmailChangeRequest(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiConfirmEmailChangeRequestMutationResult = NonNullable<Awaited<ReturnType<typeof apiConfirmEmailChangeRequest>>>
    export type ApiConfirmEmailChangeRequestMutationBody = BodyType<VerifyOtpBodyDto>
    export type ApiConfirmEmailChangeRequestMutationError = ErrorType<BackendErrorEntity>

    export const useApiConfirmEmailChangeRequest = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiConfirmEmailChangeRequest>>, TError,{data: BodyType<VerifyOtpBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof apiConfirmEmailChangeRequest>>,
        TError,
        {data: BodyType<VerifyOtpBodyDto>},
        TContext
      > => {

      const mutationOptions = getApiConfirmEmailChangeRequestMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const apiVerifyEmailChange = (
    verifyOtpBodyDto: MaybeRef<VerifyOtpBodyDto>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      verifyOtpBodyDto = unref(verifyOtpBodyDto);
      
      return fetchApiInstance<LoginEntity>(
      {url: `/account/verifyEmailChange`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: verifyOtpBodyDto
    },
      options);
    }
  


export const getApiVerifyEmailChangeMutationOptions = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiVerifyEmailChange>>, TError,{data: BodyType<VerifyOtpBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiVerifyEmailChange>>, TError,{data: BodyType<VerifyOtpBodyDto>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiVerifyEmailChange>>, {data: BodyType<VerifyOtpBodyDto>}> = (props) => {
          const {data} = props ?? {};

          return  apiVerifyEmailChange(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiVerifyEmailChangeMutationResult = NonNullable<Awaited<ReturnType<typeof apiVerifyEmailChange>>>
    export type ApiVerifyEmailChangeMutationBody = BodyType<VerifyOtpBodyDto>
    export type ApiVerifyEmailChangeMutationError = ErrorType<BackendErrorEntity>

    export const useApiVerifyEmailChange = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiVerifyEmailChange>>, TError,{data: BodyType<VerifyOtpBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof apiVerifyEmailChange>>,
        TError,
        {data: BodyType<VerifyOtpBodyDto>},
        TContext
      > => {

      const mutationOptions = getApiVerifyEmailChangeMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const apiResendEmailChangeVerifyOtp = (
    sendOtpBodyDto: MaybeRef<SendOtpBodyDto>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      sendOtpBodyDto = unref(sendOtpBodyDto);
      
      return fetchApiInstance<void>(
      {url: `/account/resendEmailChangeVerifyOtp`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: sendOtpBodyDto
    },
      options);
    }
  


export const getApiResendEmailChangeVerifyOtpMutationOptions = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiResendEmailChangeVerifyOtp>>, TError,{data: BodyType<SendOtpBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiResendEmailChangeVerifyOtp>>, TError,{data: BodyType<SendOtpBodyDto>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiResendEmailChangeVerifyOtp>>, {data: BodyType<SendOtpBodyDto>}> = (props) => {
          const {data} = props ?? {};

          return  apiResendEmailChangeVerifyOtp(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiResendEmailChangeVerifyOtpMutationResult = NonNullable<Awaited<ReturnType<typeof apiResendEmailChangeVerifyOtp>>>
    export type ApiResendEmailChangeVerifyOtpMutationBody = BodyType<SendOtpBodyDto>
    export type ApiResendEmailChangeVerifyOtpMutationError = ErrorType<BackendErrorEntity>

    export const useApiResendEmailChangeVerifyOtp = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiResendEmailChangeVerifyOtp>>, TError,{data: BodyType<SendOtpBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof apiResendEmailChangeVerifyOtp>>,
        TError,
        {data: BodyType<SendOtpBodyDto>},
        TContext
      > => {

      const mutationOptions = getApiResendEmailChangeVerifyOtpMutationOptions(options);

      return useMutation(mutationOptions);
    }
    